// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @18/04/2023 14:56:21
import { FormTemplate_abstract } from './../abstract/SagaSchema/FormTemplate_abstract';
export class FormTemplate extends FormTemplate_abstract {}
